import { PushProviderPanel } from './push-provider-panel';
import { useFcmForm, type UseFcmFormOptions } from './use-fcm-form';

export type FcmProviderFormProps = UseFcmFormOptions;

export function FcmProviderForm(props: FcmProviderFormProps) {
  const form = useFcmForm(props);
  return <PushProviderPanel {...props} form={form} />;
}
